var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tip-container",
      class: "tip-container__" + _vm.tipData.type,
      style: _vm.containerStyle,
    },
    [
      _c("span", { staticClass: "arrow-container", style: _vm.arrowPos }, [
        _c("span", { staticClass: "arrow" }),
      ]),
      _c("div", { staticClass: "tip-content" }, [
        _vm._v(" " + _vm._s(_vm.tipData.message) + " "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }